import { configResponsive, useResponsive } from 'ahooks';

export const useMobile = () => {
  configResponsive({
    small: 768,
    middle: 992,
    large: 1200,
  });

  const responsive = useResponsive();

  return {
    isMobile: !responsive.small,
  };
};
